import React from 'react'
import { OnboardingForm } from '@features/OnboardingForm'

export const TestComponents: React.FC = () => {
  // Check if the current hostname matches the production domain
  const isProduction = window.location.hostname === 'app.leadsbridge.com'

  if (isProduction) {
    // Prevent this page from appearing in production :)
    return null
  }

  return (
    <div>
      <OnboardingForm
        initialValues={{
          position: '',
          companyName: '',
          industry: '',
          capacity: '',
          country: '',
          sourceApp: '',
          budget: '',
          destinationApp: '',
          goal: '',
          secondaryGoal: '',
        }}
        onSubmit={async (values, formikHelpers) => {
          console.log('Form submitted with values:', values)
          formikHelpers.setSubmitting(false)
        }}
      />
    </div>
  )
}
